import { render, staticRenderFns } from "./TransferFrom.vue?vue&type=template&id=069b68d1&scoped=true"
import script from "./TransferFrom.vue?vue&type=script&lang=js"
export * from "./TransferFrom.vue?vue&type=script&lang=js"
import style0 from "./TransferFrom.vue?vue&type=style&index=0&id=069b68d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b68d1",
  null
  
)

export default component.exports